import React, { useEffect, useState } from 'react';
import GoogleCalendarApi from '../api/GoogleCalendarApi';

const GoogleAuthCallback = () => {
  const [status, setStatus] = useState('🔄 Processing authentication...');

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        // Handle OAuth error
        if (error) {
          setStatus('❌ Authentication failed: ' + error);
          
          if (window.opener) {
            window.opener.postMessage({
              type: 'GOOGLE_AUTH_ERROR',
              error: `Authentication failed: ${error}`
            }, '*');
          }
          
          setTimeout(() => window.close(), 2000);
          return;
        }

        // Handle missing code
        if (!code) {
          setStatus('❌ No authorization code received');
          
          if (window.opener) {
            window.opener.postMessage({
              type: 'GOOGLE_AUTH_ERROR',
              error: 'No authorization code received'
            }, '*');
          }
          
          setTimeout(() => window.close(), 2000);
          return;
        }

        // Exchange code for tokens
        setStatus('🔄 Exchanging code for tokens...');
        
        const response = await GoogleCalendarApi.handleCallback(code);

        if (response.success && response.tokens) {
          setStatus('✅ Success! Tokens saved to database. Closing...');

          // Send tokens to parent window
          if (window.opener) {
            window.opener.postMessage({
              type: 'GOOGLE_AUTH_SUCCESS',
              tokens: response.tokens
            }, '*');
          }

          // Close popup after 1.5 seconds
          setTimeout(() => {
            window.close();
          }, 1500);

        } else {
          setStatus('❌ Token exchange failed: ' + (response.message || 'Unknown error'));
          
          if (window.opener) {
            window.opener.postMessage({
              type: 'GOOGLE_AUTH_ERROR',
              error: response.message || 'Token exchange failed'
            }, '*');
          }
          
          setTimeout(() => window.close(), 2000);
        }

      } catch (error) {
        setStatus('❌ Error: ' + error.message);

        if (window.opener) {
          window.opener.postMessage({
            type: 'GOOGLE_AUTH_ERROR',
            error: error.message || 'Authentication failed'
          }, '*');
        }

        setTimeout(() => window.close(), 2000);
      }
    };

    handleAuthCallback();
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      flexDirection: 'column',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          🔐
        </div>
        
        <h2 style={{ 
          margin: '0 0 20px 0',
          color: '#333',
          fontSize: '24px'
        }}>
          Google Authentication
        </h2>
        
        <div style={{ 
          padding: '15px 20px',
          background: status.includes('✅') ? '#d4edda' : status.includes('❌') ? '#f8d7da' : '#fff3cd',
          border: `1px solid ${status.includes('✅') ? '#c3e6cb' : status.includes('❌') ? '#f5c6cb' : '#ffeaa7'}`,
          borderRadius: '8px',
          color: status.includes('✅') ? '#155724' : status.includes('❌') ? '#721c24' : '#856404',
          fontSize: '16px',
          fontWeight: '500',
          minHeight: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {status}
        </div>

        {status.includes('✅') && (
          <div style={{
            marginTop: '20px',
            padding: '15px',
            background: '#e7f3ff',
            border: '1px solid #b3d9ff',
            borderRadius: '8px',
            fontSize: '14px',
            color: '#004085'
          }}>
            ✅ Tokens have been saved to the database.<br/>
            This window will close automatically.
          </div>
        )}
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
